
export const OurPricingData= [
  {
    id: 1,
    logo: "fa-solid fa-file-signature",
    title: "Compila il modulo",
    contain: "Scarica il modulo di registrazione e compilalo in tutte le sue parti. Può richiedere la tessera solo il titolare dell'azienda o dell'attività"
  },
  {
    id: 2,
    logo: "fa-solid fa-address-card",
    title: "Richiedi la tessera",
  contain: "Consegna il modulo nel tuo ITALYCASH di riferimento, ritira la tessera cliente e richiedi l'attivazione del nostro servizio E-COMMERCE"
  },
  {
    id: 3,
    logo: "fa-solid fa-user-check",
    title: "Diventa nostro cliente",
  contain: "Acquista presso i punti vendita con la tessera d'acquisto ITALYCASH. Gli acquisti sono riservati esclusivamente ai professionisti"
  },
 
];
export default OurPricingData;